import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import SET_BASE_URL from './types';
export default _defineProperty({}, SET_BASE_URL, function (state, payload) {
  var currentState = state;
  currentState.baseURL = payload;
});